import { List, ListItem } from '@mui/material'
import clsx from 'clsx'
import { NavLink } from 'react-router-dom'
import { APP_LINKS } from '../../database/app-link'
import { useAuth } from '../../hooks'
import MobileMenu from './mobile-menu'

export function Sidebar() {
  const { user } = useAuth()

  if (!user) return null

  return (
    <>
      <MobileMenu />

      <List>
        {APP_LINKS.map(({ icon, label, link, roles }) => {
          if (!roles.includes(user.accessLevel)) return null
          else
            return (
              <ListItem className="text-sm w-full !px-0.5 !py-1" key={label}>
                <NavLink
                  to={link}
                  className={({ isActive }) =>
                    clsx(
                      isActive
                        ? 'bg-backgroundHover text-primary'
                        : 'hover:bg-backgroundHover text-white',
                      'w-full gap-2 py-3 px-6 rounded-xl no-underline flex items-center',
                    )
                  }
                >
                  {icon}

                  {label}
                </NavLink>
              </ListItem>
            )
        })}
      </List>
    </>
  )
}
